import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Pipe({
    name: 'firstError',
    standalone: false
})
export class FirstValidationErrorPipe implements PipeTransform {
  transform(validationErrors: ValidationErrors): string {

    if(!(!!validationErrors))
        return "";

    var keys = Object.keys(validationErrors);
    if (keys && keys.length>0) {
      return keys[0];
    }

    return "";
  }
}